import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductGroupReferences } from '@product/const';
import { CustomProductActions, OccProductGroupReferencesService } from '@product/data-access';
import { ProductReference } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

@Injectable()
export class ProductGroupReferencesEffects {
  loadGroups$: Observable<
    CustomProductActions.LoadGroupReferencesFail | CustomProductActions.LoadGroupReferencesSuccess
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomProductActions.LOAD_GROUP_REFERENCES),
      mergeMap((action: CustomProductActions.LoadGroupReferences) => {
        const { productCode, referenceType } = action;

        return this.occProductGroupReferencesService.loadGroups(productCode, referenceType).pipe(
          map(
            (groups: ProductGroupReferences[]) =>
              new CustomProductActions.LoadGroupReferencesSuccess(productCode, referenceType, groups),
          ),
          catchError((e: unknown) =>
            of(new CustomProductActions.LoadGroupReferencesFail(productCode, referenceType, e)),
          ),
        );
      }),
    ),
  );

  loadProducts$: Observable<
    CustomProductActions.LoadProductGroupReferencesFail | CustomProductActions.LoadProductGroupReferencesSuccess
  > = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomProductActions.LOAD_PRODUCT_GROUP_REFERENCES),
      mergeMap((action: CustomProductActions.LoadProductGroupReferences) => {
        const { productCode, referenceType, categoryCode, pageSize } = action;

        return this.occProductGroupReferencesService
          .loadProducts(productCode, referenceType, categoryCode, pageSize)
          .pipe(
            map(
              (products: ProductReference[]) =>
                new CustomProductActions.LoadProductGroupReferencesSuccess(
                  productCode,
                  referenceType,
                  categoryCode,
                  products,
                ),
            ),
            catchError((e: unknown) =>
              of(new CustomProductActions.LoadProductGroupReferencesFail(productCode, referenceType, categoryCode, e)),
            ),
          );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private occProductGroupReferencesService: OccProductGroupReferencesService,
  ) {}
}
